/** Mirrors Data's `AcxAgentArtifactType`, which is serialized as a number. */
export enum AgentArtifactType {
    PowerPoint = 0,
}

export interface AgentArtifact {
    type: AgentArtifactType;
    name: string;
    artifactId: string;
    storageAccountId: string;
    directoryId: string;
    fileName: string;
    createdOn: string;
    sizeBytes: number;
}

export interface PowerPointArtifact extends AgentArtifact {
    type: AgentArtifactType.PowerPoint;
    slideCount: number;
    thumbnailFileName?: string;
    scriptFileName?: string;
}

export function isPowerPointArtifact(
    artifact: AgentArtifact,
): artifact is PowerPointArtifact {
    return artifact.type === AgentArtifactType.PowerPoint;
}
